<template>
  <div
    class="short-horizontal-list section"
    :style="sectionStyle"
  >
    <div class="container">
      <div class="row">
        <div
          v-for="(item, index) in items"
          :key="index"
          class="col-md-4 col-xs-12"
        >
          <div class="item flex no-wrap items-center">
            <div>
              <div class="icon-border">
                <q-icon
                  v-if="item.icon"
                  :name="item.icon"
                />
              </div>
            </div>
            <div>
              <div
                :style="sublabelStyle"
                v-text="item.sublabel"
              />
              <div
                :style="descriptionStyle"
                v-text="item.description"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import backgroundMixin from './mixins/backgroundMixin';
import descriptionMixin from './mixins/descriptionMixin';
import sublabelMixin from './mixins/sublabelMixin';

export default {
  name: 'ShortHorizontalListSection',
  mixins: [
    backgroundMixin,
    descriptionMixin,
    sublabelMixin,
  ],
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
